import logger from '../../../utils/logger';
import { DeviceStatus } from '../../../constants/DeviceStatus';
import { Material } from '../../../../types/api/Material';
import { Device } from '../../../../types/api/Device';

export const updateDeviceStatuses = (
  batchStore: any,
  materialStore: any,
  originalBin: Device,
  substituteBin: Device,
  scaleId: string,
  substituteMaterial: Material,
  currentWeight: number,
  currentScaleWeight: number,
  deferredWeight: number,
  scaleData: any,
  constituent: any,
) => {
  const substituteMaterialCode = materialStore.getMaterialName(substituteMaterial);

  if (batchStore.isHoldFeedDevice(originalBin.id)) {
    batchStore.holdFeedDevices = batchStore.holdFeedDevices.filter((id: any) => id !== originalBin.id);
  }

  batchStore.holdFeedDevice(substituteBin.id);
  logger.log('Transferred hold state from bin', originalBin.id, 'to bin', substituteBin.id);

  if (originalBin?.id) {
    batchStore.deviceStatus.set(originalBin.id, {
      ...batchStore.getDeviceStatus(originalBin.id),
      status: DeviceStatus.FINISH,
      substitutionNote: `Material switched to ${substituteMaterialCode}`,
      target: currentWeight,
      weight: currentWeight,
    });
  }

  const currentScaleStatus = batchStore.getDeviceStatus(scaleId);
  const currentSubstituteBinStatus = batchStore.getDeviceStatus(substituteBin.id);

  logger.log('[DEVICE_STATUS] Setting substitute bin status', {
    substituteBinId: substituteBin.id,
    currentScaleWeight,
    prevWeight: currentScaleWeight,
    currentWeight,
    target: scaleData.mft,
    currentSubstituteBinStatus: currentSubstituteBinStatus,
  });

  const newStatus = {
    ...currentSubstituteBinStatus,
    prevWeight: currentScaleWeight,
    weight: currentSubstituteBinStatus.weight,
    target: scaleData.mft - currentWeight,
    status: DeviceStatus.HOLD,
  };

  batchStore.deviceStatus.set(substituteBin.id, newStatus);

  // Verify it was set correctly
  const verifyStatus = batchStore.getDeviceStatus(substituteBin.id);
  logger.log('[DEVICE_STATUS] Verified substitute bin status after setting', {
    substituteBinId: substituteBin.id,
    prevWeight: verifyStatus.prevWeight,
    weight: verifyStatus.weight,
    fullStatus: verifyStatus,
  });

  batchStore.deviceStatus.set(scaleId, {
    ...currentScaleStatus,
    materialCode: substituteMaterialCode,
    mCode: constituent ? constituent.mixItemCode : substituteMaterialCode,
  });
};
